import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import get from 'lodash/get';
import inRange from 'lodash/inRange';
import { success as requestSuccess, error as requestError } from '@flowio/request';
import { isNil } from '@flowio/is';
import ShopifySessionClient from './shopify';
import OrganizationSessionClient from './organization';
import { isErrorResponse, isFlowSession } from '../types';

var SessionClient = /*#__PURE__*/function () {
  function SessionClient(_ref) {
    var apiBaseUri = _ref.apiBaseUri;

    _classCallCheck(this, SessionClient);

    this.apiBaseUri = apiBaseUri;
    this.shopifySessionClient = new ShopifySessionClient({
      apiBaseUri: this.apiBaseUri
    });
    this.organizationSessionClient = new OrganizationSessionClient({
      apiBaseUri: this.apiBaseUri
    });
  }

  _createClass(SessionClient, [{
    key: "getClient",
    value: function getClient() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var integration = SessionClient.getIntegration(options);
      var client;

      if (integration === 'shopify') {
        client = this.shopifySessionClient;
      } else {
        client = this.organizationSessionClient;
      }

      return client;
    }
  }, {
    key: "createSession",
    value: function createSession() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var integration = SessionClient.getIntegration(options);

      if (integration === 'shopify') {
        if (isNil(options.shop)) {
          throw new Error('createSession: Missing required parameter: shop');
        }

        this.shopifySessionClient.createSession(options.shop, function (status, response) {
          if (SessionClient.requestSuccessful(status) && isFlowSession(response)) {
            requestSuccess(options, response);
          } else {
            requestError(options, SessionClient.formatApiErrorResponse(status, response));
          }
        });
      } else {
        if (isNil(options.organizationId)) {
          throw new Error('createSession: Missing required parameter: shop');
        }

        this.organizationSessionClient.createSession(options.organizationId, function (status, response) {
          if (SessionClient.requestSuccessful(status) && isFlowSession(response)) {
            requestSuccess(options, response);
          } else {
            requestError(options, SessionClient.formatApiErrorResponse(status, response));
          }
        });
      }
    }
  }, {
    key: "getSession",
    value: function getSession() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var sessionId = get(options, 'sessionId');
      var client = this.getClient(options);

      if (isNil(sessionId)) {
        requestError(options, 'getSession: missing sessionId');
        return;
      }

      client.getSession(sessionId, function (status, response) {
        if (SessionClient.requestSuccessful(status) && isFlowSession(response)) {
          requestSuccess(options, response);
        } else {
          requestError(options, SessionClient.formatApiErrorResponse(status, response));
        }
      });
    }
  }, {
    key: "resetSession",
    value: function resetSession(options) {
      var sessionId = options.sessionId;

      if (isNil(sessionId)) {
        throw new Error('resetSession: missing sessionId');
      }

      var client = this.getClient(options);
      var form = {
        country: get(options, 'geo.country'),
        currency: get(options, 'geo.currency'),
        language: get(options, 'geo.language'),
        experience: get(options, 'experience'),
        locale: get(options, 'geo.locale'),
        attributes: get(options, 'attributes')
      };
      client.resetSession(sessionId, form, function (status, response) {
        if (SessionClient.requestSuccessful(status) && isFlowSession(response)) {
          requestSuccess(options, response);
        } else {
          requestError(options, SessionClient.formatApiErrorResponse(status, response));
        }
      });
    }
  }, {
    key: "clearSession",
    value: function clearSession() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var sessionId = options.sessionId;

      if (isNil(sessionId)) {
        throw new Error('resetSession: missing sessionId');
      }

      var client = this.getClient(options);
      client.clearSession(sessionId, function (status, response) {
        if (SessionClient.requestSuccessful(status) && isFlowSession(response)) {
          requestSuccess(options, response);
        } else {
          requestError(options, SessionClient.formatApiErrorResponse(status, response));
        }
      });
    }
  }], [{
    key: "getIntegration",
    value: function getIntegration() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var sessionType = options.sessionType || 'organization';
      var fallbackIntegration = sessionType === 'shopify' ? sessionType : 'default';
      return options.integration || fallbackIntegration;
    }
  }, {
    key: "requestSuccessful",
    value: function requestSuccessful(status) {
      return inRange(status, 200, 300);
    }
  }, {
    key: "formatApiErrorResponse",
    value: function formatApiErrorResponse(status, response) {
      if (isErrorResponse(response)) {
        return "Got error back from server status[".concat(status, "] code[").concat(String(response.error.code), "] message[").concat(String(response.error.messages.join(', ')), "]");
      }

      return "Unknown error: ".concat(JSON.stringify(response));
    }
  }]);

  return SessionClient;
}();

export { SessionClient as default };
//# sourceMappingURL=session.js.map